import React from 'react';
import { Typography, TypographyType, TypographyVariant } from 'src/components-dummy';
import { ControlSnapshotPanelProps } from './types';
import './ControlSnapshotPanel.scss';

const DEFAULT_DESCRIPTION =
  "A snapshot of your live shop config taken at launch. It won't drift when someone edits the shop mid-test.";
const DEFAULT_FOOTER_NOTE =
  'Production keeps serving the live, editable config. Allocation is set in the traffic step.';

export const ControlSnapshotPanel = ({
  items,
  description = DEFAULT_DESCRIPTION,
  note,
  footerNote = DEFAULT_FOOTER_NOTE,
}: ControlSnapshotPanelProps): JSX.Element => (
  <div className='syte-control-snapshot-panel'>
    <div className='syte-control-snapshot-panel-header'>
      <span className='syte-control-snapshot-panel-dot' />
      <Typography type={TypographyType.Body} variant={TypographyVariant.MediumBold}>
        Control (A)
      </Typography>
      <span className='syte-control-snapshot-panel-badge'>frozen at launch</span>
    </div>
    <Typography
      type={TypographyType.Body}
      variant={TypographyVariant.SmallRegular}
      className='syte-control-snapshot-panel-description'
    >
      {description}
    </Typography>
    <ul className='syte-control-snapshot-panel-list'>
      {items.map(item => (
        <li key={item.label}>
          <span className='syte-control-snapshot-panel-list-label'>{item.label}</span>
          <span className='syte-control-snapshot-panel-list-value'>{item.value}</span>
        </li>
      ))}
    </ul>
    {note && (
      <Typography
        type={TypographyType.Body}
        variant={TypographyVariant.SmallRegular}
        className='syte-control-snapshot-panel-note'
      >
        {note}
      </Typography>
    )}
    <Typography
      type={TypographyType.Body}
      variant={TypographyVariant.SmallRegular}
      className='syte-control-snapshot-panel-footer'
    >
      {footerNote}
    </Typography>
  </div>
);
